import { s, h } from '../lib/sx'
import { A } from '../lib/router'
import { Plate } from '../components/Plate'
import type { Service, ServiceDetail as Detail } from '../content/services'

export function ServiceDetail({ service, detail }: { service: Service; detail: Detail }) {
  return (
    <div>
      <section style={s('background:#1B2430;color:#F2F4F6;')}>
        <div style={s('max-width:1320px;margin:0 auto;padding:clamp(48px,7vw,56px) clamp(18px,4vw,32px) clamp(48px,7vw,76px);')}>
          <A href="/services" style={s("font-family:'IBM Plex Mono',monospace;font-size:11px;letter-spacing:0.16em;text-transform:uppercase;color:#8C97A4;")} className={h('color:#FFFFFF;')}>
            ← All services
          </A>
          <div style={s("font-family:'IBM Plex Mono',monospace;font-size:11px;letter-spacing:0.24em;text-transform:uppercase;color:#E06A20;margin-top:34px;")}>{service.no}</div>
          <h1 style={s('font-family:Archivo,sans-serif;font-weight:800;font-size:clamp(40px,5vw,70px);line-height:0.96;letter-spacing:-0.038em;margin:20px 0 0;max-width:900px;')}>{service.title}</h1>
        </div>
      </section>

      <section style={s('max-width:1320px;margin:0 auto;padding:clamp(48px,7vw,80px) clamp(18px,4vw,32px);display:grid;grid-template-columns:repeat(auto-fit,minmax(min(100%,340px),1fr));gap:clamp(40px,5vw,80px);align-items:start;')}>
        <div>
          <p style={s('font-size:20px;line-height:1.55;margin:0 0 40px;text-wrap:pretty;')}>{detail.lead}</p>
          <div style={s("font-family:'IBM Plex Mono',monospace;font-size:11px;letter-spacing:0.2em;text-transform:uppercase;color:#7E8894;margin-bottom:18px;")}>Scope we cover</div>
          <div style={s('display:flex;flex-direction:column;border-top:1px solid #DCE0E5;')}>
            {detail.scope.map((item, i) => (
              <div key={i} style={s('padding:15px 0;border-bottom:1px solid #DCE0E5;font-size:15.5px;color:#1B2430;')}>
                {item}
              </div>
            ))}
          </div>
        </div>

        <div>
          <Plate box="aspect-ratio:4/3;display:flex;align-items:flex-end;padding:16px;margin-bottom:32px;" src={service.image} caption={service.title} captionStyle="padding:6px 8px;" />
          <div style={s('display:grid;grid-template-columns:repeat(auto-fit,minmax(min(100%,250px),1fr));gap:1px;background:#DCE0E5;border:1px solid #DCE0E5;margin-bottom:32px;')}>
            {detail.stat.map(([value, label], i) => (
              <div key={i} style={s('background:#F2F4F6;padding:22px 18px;')}>
                <div style={s('font-family:Archivo,sans-serif;font-weight:700;font-size:22px;letter-spacing:-0.02em;')}>{value}</div>
                <div style={s("font-family:'IBM Plex Mono',monospace;font-size:10px;letter-spacing:0.1em;text-transform:uppercase;color:#7E8894;margin-top:8px;line-height:1.5;")}>{label}</div>
              </div>
            ))}
          </div>
          <div style={s('background:#1B2430;color:#F2F4F6;padding:30px 28px;')}>
            <div style={s("font-family:'IBM Plex Mono',monospace;font-size:10.5px;letter-spacing:0.18em;text-transform:uppercase;color:#E06A20;margin-bottom:14px;")}>Credentials</div>
            {detail.creds.map((c, i) => (
              <div key={i} style={s('font-size:14.5px;line-height:1.9;color:#B8C0CA;')}>
                {c}
              </div>
            ))}
            <A href="/quote" style={s('display:inline-block;background:#1F5C99;color:#FFFFFF;padding:13px 22px;font-size:13.5px;font-weight:600;margin-top:22px;')} className={h('background:#17497A;color:#FFFFFF;')}>
              Request a quote
            </A>
          </div>
        </div>
      </section>
    </div>
  )
}
